import { Dispatch, FC, SetStateAction } from 'react'
import { Button, Divider } from 'rsuite'
import { useFeatureValue } from '@growthbook/growthbook-react'
import useTranslation from 'next-translate/useTranslation'

import CategoryIcon from '../../../Catalog/CategoryIcon'
import MobileCategoryPicker from './MobileCategoryPicker'
import MobileMegaMenu from '../MegaMenu/MobileMegaMenu'
import useMegaMenuData from '../../../../services/strapi/useMegaMenuData'
import { Catalog } from '../../../../utils/types/Product'

import headerStyles from '../../../../styles/Header.module.less'

interface SubCategoriesMenuProps {
  breadcrumb: Catalog[]
  selectedSubCategory: Catalog
  categoriesLoading: boolean
  isSubCategoriesLoading: boolean
  setBreadcrumb: (value: SetStateAction<Catalog[]>) => void
  setAnimationDirection: Dispatch<SetStateAction<'forward' | 'backward' | null>>
  handleSubCategoryClick: (categoryCode: string) => void
}

const SubCategoriesMenu: FC<SubCategoriesMenuProps> = (props) => {
  const {
    breadcrumb,
    selectedSubCategory,
    categoriesLoading,
    isSubCategoriesLoading,
    setBreadcrumb,
    setAnimationDirection,
    handleSubCategoryClick,
  } = props

  const { t } = useTranslation('common')

  const columnsData = useMegaMenuData()
  const categoryMediaVariant = useFeatureValue<string>('category-media-variant', 'none')

  const activeCategory = breadcrumb.at(-1) || selectedSubCategory || {}
  const selectedTopCategoryCode = breadcrumb.at(0)?.['catalog.code'] || ''

  const getRelevantColumnsData = (categoryCode: string) => columnsData[categoryCode]

  if (!selectedSubCategory || categoriesLoading || isSubCategoriesLoading) {
    return null
  }

  return (
    <>
      <Button
        appearance="subtle"
        className="margin-bottom-spacer padding-zero"
        onClick={() => handleSubCategoryClick(activeCategory['catalog.code'])}
      >
        <div className={headerStyles['mobile-category-item']}>
          {categoryMediaVariant !== 'none' && (
          <CategoryIcon
            media={activeCategory.media}
            categoryName={activeCategory['catalog.label']}
            size={32}
            type={categoryMediaVariant === 'images-only' ? 'default' : undefined}
            className={headerStyles['mobile-category-icon']}
          />
          )}
          <span className={headerStyles['selected-category-text']}>
            {t('All')}
            {' '}
            {activeCategory?.['catalog.label']}
          </span>
        </div>
      </Button>

      <MobileCategoryPicker
        handleSelectAndCloseMenus={(categoryCode) => {
          if (categoryCode) {
            handleSubCategoryClick(categoryCode)
          }
        }}
        setBreadcrumb={setBreadcrumb}
        breadcrumb={breadcrumb}
        setAnimationDirection={setAnimationDirection}
        selectedSubCategory={selectedSubCategory}
      />

      <Divider />

      <MobileMegaMenu
        columnsData={getRelevantColumnsData(selectedTopCategoryCode)}
        handleMenuLinkClick={() => {
          if (selectedSubCategory) {
            handleSubCategoryClick(selectedSubCategory['catalog.code'])
          }
        }}
      />
    </>
  )
}

export default SubCategoriesMenu
